export default "__VITE_ASSET__Dh1AHi98__"